// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiConfig } from "../../apiConfig";
import { getHeaders, ApiScope } from "../silentAuth";

// Define a service using a base URL and expected endpoints
export const objectsApi = createApi({
  reducerPath: "objectsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${apiConfig.baseApiUrl}objects/v2/`,
    prepareHeaders: async (headers, { getState }) => {
      return await getHeaders(ApiScope, headers);
    },
  }),
  tagTypes: ["Objects"],
  endpoints: (builder) => ({
    getObjectsInResourceGroup: builder.query<any[], { resourceGroupId: string; modelId: string }>({
      query: ({ resourceGroupId, modelId }) => `/objects/${resourceGroupId}?modelId=${modelId}`,
      transformResponse: (response: { data: any[] }, meta, arg) => response.data,
      providesTags: ["Objects"],
    }),
    getHierarchyById: builder.query<any[], { objectId: string; resourceGroupId: string }>({
      query: ({ objectId, resourceGroupId }) => `/objectrelations/${resourceGroupId}/${objectId}/hierarchy`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetObjectsInResourceGroupQuery, useGetHierarchyByIdQuery } = objectsApi;
